import cookies from 'react-cookies';
let isLogin = () => {
    let token = cookies.load('token_customer');
    return (typeof(token) !== "undefined" && token !== '' && token !== null);
}

export default isLogin;
